
<style lang="less">
    .propertyList{
        border: 1px solid #d7dde4;
        background: #efefef;
        height: 100%;
        position: relative;
        .head{
            /*height: 46px;*/
            padding-top: 10px;
            margin-bottom: 5px;
        h1{
            display: inline;
            margin-left: 20px;
            }
        .searchArea{
            display: inline-block;
            margin-left: 20px;
        }
        .query-bar {
            padding: 5px;
            margin-top: 10px;
            /*background: #d8edff;*/
            background: #fff;
            .btn-span{
                display: inline-block;
                font-size: 16px;
                cursor: pointer;
                margin-right: 15px;
            }
            .btn-span:hover{
                color:#2d8cf0;
            }
            .icon {
                font-size: 16px;
            }
        .ivu-form-item {
            margin-bottom: 0px;
        }
        }
        }
        .layout-breadcrumb{
            padding: 10px 15px 0px ;
            /*border-bottom: 1px solid #e3e3e3;*/
        }
        .layout-content{
            /*min-height: 80vh;*/
            margin: 15px;
            overflow: hidden;
            background: #fff;
            border-radius: 4px;
        }
        .layout-content-main{
            padding: 10px;
            min-height: 308px;
        }
        .table th{
            background-color: #00c0ff;
            color: #fff;
        }
        Form textarea{
            width: 100%;
            height: 100%;
        }
        .footer{
            margin-top: 10px;
            width: 100%;
            height: 46px;
        }
        .btn{
            width: 120px;
            height: 35px;
            font-size: 15px;
            margin-left: 20px;
        }
        /*.ivu-table-column-center{*/
            /*background-color: #f7f7f7;*/
        /*}*/
    .ivu-table-border td, .ivu-table-border th{
            border: 1px solid #c1c1c1;
        }
    }
    .ivu-table .demo-table-info-row td{
        color: #f50807;
    }
    .image-view {
        text-align: center;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: #000000;
        z-index: 1000;
        img{
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
        }
    }
    .checkEditorModal{
        .ivu-modal {
            width: 212mm !important;
            height: calc(~'100% - 100px');
            .ivu-modal-content{
                height: 100%;
            }
            .ivu-modal-body {
                height: calc(~'100% - 112px');
                overflow: auto;
            .border-bottom{
                border-bottom: 1px solid #ddd;
            }
            .form-body {
                /*.device-content {*/
                    /*margin-bottom: 10px;*/
                    /*background: #fafafb;*/
                    /*padding-bottom: 10px;*/
                    /*border-radius: 5px;*/
                /*}*/
            }
            }
        .remark-img-part {
        .img-list {
        .img-item {
            position: relative;
            float: left;
            margin-right: 9px;
            margin-bottom: 9px;
            width: 79px;
            height: 79px;
            background: no-repeat 50%;
            background-size: cover;
        .icon-remove {2
            position: absolute;
            right: 2px;
            top: 2px;
            padding: 0px 5px;
            cursor: pointer;
            border-radius: 50%;
            background: #FF4949;
            color: #fff;
            display: -webkit-box;
            display: -webkit-flex;
            display: -ms-flexbox;
            display: none;
            -webkit-box-align: center;
            -webkit-align-items: center;
            -ms-flex-align: center;
            align-items: center;
            justify-content: center;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }
        }
        .img-item:hover{
        .icon-remove {
            display:flex;
        }
        }
        }
        .uploader_input_wrp {
            cursor: pointer;
            float: left;
            position: relative;
            margin-right: 9px;
            margin-bottom: 9px;
            width: 79px;
            height: 79px;
            border: 1px solid #d9d9d9;
        }
        .uploader_input_wrp:before{
            width: 2px;
            height: 39.5px;
        }
        .uploader_input_wrp:after{
            width: 39.5px;
            height: 2px;
        }
        .uploader_input_wrp:before,.uploader_input_wrp:after {
            content: " ";
            position: absolute;
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%,-50%);
            transform: translate(-50%,-50%);
            background-color: #d9d9d9;
        }
        }
        }
    }
    .dangerousSource-Field-modal {
        .ivu-modal-body {
            padding: 0px;
        }
        .column-select-list {
            height: 300px;
            overflow: auto;
            .check-item {
                display: block;
                padding:5px 0px 5px 16px;
            }
            .check-item:hover {
                background: rgba(255, 219, 119,0.6)
            }
            .checkbox1{
                display: block;
                position: relative;

            }
            .checkbox1>span.ivu-checkbox{
                display: none;
            }
            .checkbox1>label{
                width: 79%;
            }
        }
        .ivu-modal-footer {
            padding: 0px;
            border-top: none;
        }
    }
    .qrCode .ivu-modal{
        width: 520px!important;
    }



</style>
<template>
    <div class="propertyList">
        <Row>
            <i-col span="24">
                <div class="layout-breadcrumb">
                    <Breadcrumb>
                        <BreadcrumbItem >资产管理</BreadcrumbItem>
                        <BreadcrumbItem>资产信息列表</BreadcrumbItem>
                    </Breadcrumb>
                </div>
                <div class="layout-content">
                    <div class="layout-content-main">
                        <div class="head">
                            <h1 >资产信息列表</h1>
                            <Button  class="btn" @click="add" type="primary">资产信息提取</Button>
                            <div class="query-bar">
                                <Form ref="formInline" :model="formInline" inline :label-width="80">
                                    <span class="btn-span" style="position: relative">
                                        <span @click="columnFieldsModalShow= true">
                                            <i class="iconfont icon icon-shezhi"></i>
                                            筛选列表字段
                                        </span>
                                        <Modal v-model="columnFieldsModalShow" :width="300" class-name="dangerousSource-Field-modal">
                                            <div slot="close"></div>
                                            <div slot="header">
                                                <Checkbox v-model="checkAllField" @on-change="handleCheckAllField">勾选你要显示的字段</Checkbox>
                                            </div>
                                            <div class="column-select-list">
                                                <CheckboxGroup v-model="tableColumnTitles" @on-change="fieldItemChange">
                                                    <Checkbox v-for="field in columnFields" class="checkbox1">
                                                        <Checkbox  :label="field" class="check-item" :key="field" style="display: inline-block">
                                                            <span style="flex: 1;white-space: nowrap;text-overflow: ellipsis">{{field}}</span>
                                                        </Checkbox>
                                                        <div style="display: inline-block;position: absolute;right: 0">
                                                            <span>
                                                                <i class="iconfont icon-xiangshang" style="color: #f5bc21;padding:0.2rem;border-radius: 50%;background: #fff" @click.stop="handleFieldSort(field,'up')"></i>
                                                                <i class="iconfont icon-xiangxia" style="color: #0bb20c;padding:0.2rem;border-radius: 50%;background: #fff" @click.stop="handleFieldSort(field,'down')"></i>
                                                            </span>
                                                        </div>
                                                    </Checkbox>
                                                </CheckboxGroup>
                                            </div>
                                            <div slot="footer"></div>
                                        </Modal>
                                    </span>
                                    <Upload
                                            ref="upload"
                                            :action='this.action'
                                            :format="['xls','xlsx']"
                                            :headers="{token:this.getKey('token')}"
                                            :on-success="handleSuccess"
                                            :on-format-error="handleFormatError"
                                            :show-upload-list="false"
                                            style="display: inline-block;float: right">
                                        <Button type="ghost" icon="ios-cloud-upload-outline" style="background-color: #4d7ff2;color: #fff">批量导入</Button>
                                    </Upload>
                                    <Button type="primary"  style="display: inline-block;float: right;margin-right: 10px" @click="download_tmp">下载模板</Button>
                                    <Form-item label="增加日期" prop="time">
                                        <DatePicker type="date" :clearable=true placeholder="请选择" format="yyyy-MM-dd" @on-change="qltime"  class="month"></DatePicker>
                                    </Form-item>
                                    <Form-item label="状态" >
                                        <Select v-model="ql_state" clearable style="width: 168px;">
                                            <Option value="在用">在用</Option>
                                            <Option value="待报废">待报废</Option>
                                            <Option value="已报废">已报废</Option>
                                        </Select>
                                    </Form-item>
                                    <Form-item label="所属部门">
                                        <Select v-model="ql_department" clearable style="width:162px;display: inline-block">
                                            <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                                        </Select>
                                    </Form-item>
                                    <Button type="primary" @click="search">搜索</Button>
                                </Form>
                                <Collapse v-model="value1" style="background-color: #fff;margin-top: 5px;">
                                    <Panel name="1">
                                        更多搜索
                                        <template slot="content">
                                            <Form ref="formInline" :model="formInline" inline :label-width="110">
                                                <Form-item label="用友系统卡片编号">
                                                    <Input  v-model="ql_yonyou_id"></Input>
                                                </Form-item>
                                                <Form-item label="行政事业系统编号">
                                                    <Input  v-model="ql_admin_id"></Input>
                                                </Form-item>
                                                <Form-item label="固定资产名称">
                                                    <Input  v-model="ql_name"></Input>
                                                </Form-item>
                                                <Form-item label="计量单位">
                                                    <Input  v-model="ql_unit"></Input>
                                                </Form-item>
                                                <Form-item label="资产数量">
                                                    <Input  v-model="ql_count"></Input>
                                                </Form-item>
                                                <Form-item label="资产分类代码">
                                                    <Input  v-model="ql_class_code"></Input>
                                                </Form-item>
                                                <Form-item label="规格型号">
                                                    <Input  v-model="ql_model"></Input>
                                                </Form-item>
                                                <Form-item label="资产存放地点">
                                                    <Input  v-model="ql_location"></Input>
                                                </Form-item>
                                                <Form-item label="项目名称">
                                                    <Input  v-model="ql_project_name"></Input>
                                                </Form-item>
                                                <Form-item label="发票编号">
                                                    <Input  v-model="ql_invoice_number"></Input>
                                                </Form-item>
                                                <Form-item label="财务负责人">
                                                    <Input  v-model="ql_finance_person"></Input>
                                                </Form-item>
                                                <Form-item label="资金来源">
                                                    <Input  v-model="ql_fund_source"></Input>
                                                </Form-item>
                                                <Form-item label="会计凭证号">
                                                    <Input  v-model="ql_accounting_id"></Input>
                                                </Form-item>
                                                <Form-item label="供应商">
                                                    <Input  v-model="ql_supplier"></Input>
                                                </Form-item>
                                                <Form-item label="生产厂家">
                                                    <Input  v-model="ql_manufacturer"></Input>
                                                </Form-item>
                                            </Form>
                                        </template>


                                    </Panel>

                                </Collapse>
                            </div>
                        </div>
                        <div>
                            <Table size="small" border stripe :columns="tableColumns" class="table" :data="dataSourceList" @on-row-click="Detail"></Table>
                        </div>

                    </div>
                </div>
                <div class="footer">
                    <Page
                            class="pull-right"
                            :total="totalSize"
                            :current="page"
                            size="small"
                            show-total
                            @on-change="changePage"
                            :page-size='pageSize'
                    ></Page>
                </div>
                <!--调度-->
                <Modal v-model="modal_transfer" width="500">
                    <div v-if="current_modal=='trans'">
                        <h1 slot="header" style="text-align: center;color: #00c0ff">资产调拨</h1>
                        <div class="main">
                            <div>
                                <span class="ivu-form-item-label" style="font-size: 18px;">调出部门：</span>
                                <p style="display: inline-block;font-size: 18px;">{{transfer_dep}}</p>
                            </div>
                            <div style="margin-top: 30px;">
                                <span class="ivu-form-item-label" style="font-size: 18px;">调入部门：</span>
                                <Select v-model="trans_department" clearable style="width:162px;display: inline-block">
                                    <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                                </Select>
                            </div>
                        </div>
                    </div>
                    <div v-if="current_modal=='scrap'">
                        <h1 slot="header" style="text-align: center;color: #00c0ff">资产报废</h1>
                        <div class="main">
                            <div>
                                <span class="ivu-form-item-label" style="font-size: 18px;">资产名称：</span>
                                <p style="font-size: 18px;display: inline-block">{{asset_name}}</p>
                            </div>
                            <div style="margin-top: 30px;">
                                <span class="ivu-form-item-label" style="font-size: 18px;">规格型号：</span>
                                <p style="font-size: 18px;display: inline-block">{{asset_model}}</p>
                            </div>
                            <div style="margin-top: 30px;">
                                <span class="ivu-form-item-label" style="font-size: 18px;">报废状态：</span>
                                <Select v-model="scrap_type" clearable style="width:162px;display: inline-block">
                                    <Option value="待报废">待报废</Option>
                                    <Option value="已报废">已报废</Option>
                                </Select>
                            </div>
                        </div>
                    </div>
                    <div slot="footer">
                        <Button @click="modal_transfer=false">取消</Button>
                        <Button type="primary" v-if="current_modal=='trans'" @click="transferSubmit">调拨</Button>
                        <Button type="primary" v-if="current_modal=='scrap'" @click="scrapSubmit">确定报废</Button>
                    </div>

                </Modal>
                <!--借出-->
                <Modal v-model="modal_lend" width="500">
                    <h1 slot="header" style="text-align: center;color: #00c0ff">资产借出</h1>
                    <div class="main">
                        <div>
                            <span class="ivu-form-item-label" style="font-size: 18px;">所属部门：</span>
                            <p style="font-size: 18px;display: inline-block">{{lend_dep}}</p>
                        </div>
                        <div style="margin-top: 20px;">
                            <span class="ivu-form-item-label" style="font-size: 18px;">借出类型：</span>
                            <RadioGroup v-model="lend_type">
                                <Radio label="person">个人</Radio>
                                <Radio label="company">单位</Radio>
                                <Radio label="department">科室</Radio>
                            </RadioGroup>
                        </div>
                        <div style="margin-top: 20px;">
                            <div v-if="lend_type=='person'||lend_type=='company'">
                                <span class="ivu-form-item-label" v-if="lend_type=='person'" style="font-size: 18px;">借出人：</span>
                                <span class="ivu-form-item-label"  v-if="lend_type=='company'" style="font-size: 18px;">单位名称：</span>
                                <Input  v-model="lend_name" style="width: 70%;"></Input>
                            </div>
                            <div v-if="lend_type=='department'">
                                <span class="ivu-form-item-label" style="font-size: 18px;">借出科室名称：</span>
                                <Select v-model="lend_department" clearable style="width:162px;display: inline-block">
                                    <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                                </Select>
                            </div>
                        </div>
                        <div style="margin-top: 20px;">
                            <span class="ivu-form-item-label" style="font-size: 18px;">借出数量：</span>
                            <InputNumber :max="asset_count" :min="1" v-model="land_count"></InputNumber>
                        </div>
                    </div>
                    <div slot="footer">
                        <Button @click="modal_lend=false">取消</Button>
                        <Button type="primary" @click="lendSubmit">确定借出</Button>
                    </div>
                </Modal>
                <Modal v-model="modal_del" width="360">
                    <p slot="header" style="color:#f60;text-align:center">
                        <Icon type="information-circled"></Icon>
                        <span> 删除确认</span>
                    </p>
                    <div style="text-align:center">
                        <p>是否确认删除该资产信息？</p>
                    </div>
                    <div slot="footer">
                        <Button type="error" size="large" long :loading="modal_loading" @click="del">删除</Button>
                        <div style="margin-top: 10px;">
                            <Button type="primary" size="large" long @click="modal_del=false">取消</Button>
                        </div>
                    </div>
                </Modal>
                <Modal title="资产二维码" v-model="qcode" class-name="qrCode" >
                    <img :src=qcodeSrc v-if="qcode">
                    <!--<img :src=HD_code v-if="qcode" style="display: inline-block;margin-left: 20px;height: 210px;width: auto" alt="">-->
                    <div slot="footer">

                        <Button type="primary" @click="download_code">下载</Button>
                        <Button @click="qcode=false">取消</Button>
                    </div>
                </Modal>
                <iframe id="download" src="" frameborder="0" hidden></iframe>
            </i-col>

        </Row>
    </div>
</template>

<script>
    import {deepCopy} from 'iview/src/utils/assist';
    export default {
        data () {
            return {
                action:parameters.domain+'/sys/assetlist/uploadyongyouexcel',
                divingStatList: 'manage/divingrating/stat',
                deleteUrl:'manage/rescuelist/delete',
                qcodeDownUrl:'/manage/messagelist/download',
//                editUrl:'manage/userreceivelist/edit?system_id="5000000"',
                value1: "2",
                time_month: "",
                time_year: "",
                ql_yonyou_id: "",
                ql_admin_id: "",
                ql_name: "",
                ql_unit: "",
                ql_count: "",
                ql_state:'',//查询状态
                ql_department:'',//查询部门
                ql_class_code:'',
                ql_model:'',
                ql_location:'',
                ql_project_name:'',
                ql_invoice_number:'',
                ql_supplier:'',
                ql_manufacturer:'',
                ql_accounting_id:'',
                ql_finance_person:'',
                ql_fund_source:'',
                updateTitle:'',
                viewPath:'',
                del_index:'',
                transfer_dep:'',
                lend_dep:'',
                lend_time:'',
                lend_type:'',
                lend_name:'',
                lend_department:'',
                land_count:1,
                asset_count:1,
                transfer_index:'',
                trans_department:'',
                asset_name:'',
                asset_model:'',
                scrap_type:'',
                current_modal:'',
                table_id:'',
                qcodeSrc:'',
                QR_path:'',
                HD_code:'',
                currentUploadFileList:[],
                departmentList:[],
                uploadArr:[],
                totalSize:0,
                pageSize:10,
                page:1,
                formInline:{},
                dataSourceList:[],
                file:{},
                urlPrefix:parameters.domain,
                token:this.getKey('token'),
                btnChange: false,
                qcode: false,
                btnSave: false,
                type_year: false,
                type_month: true,
                modal: false,
                modal_loading: false,
                modal_del:false,
                modal_transfer:false,
                modal_lend:false,
                imageViewVisible:false,
                columnFieldsModalShow:false,
                checkAllField:true,
                tableColumnTitles:[],//要显示的table字段
                columnFields:['序号','用友系统卡片编号','行政事业系统编号','固定资产名称','增加日期','计量单位','资产数量','可借出数量','资产原值','资金来源','所属单位','所属部门','使用状况','资产存放地点','入账形式','财务负责人','供应商','生产厂家','建筑面积','车牌号码','发票编号','会计凭证号','实物保管人','备注'],
//                columnFields:['用友系统卡片编号','行政事业系统编号','固定资产名称','增加日期','计量单位','资产数量','资产原值','累计折旧','资金来源','备注'],
                columns1: [
                    {
                      title: '序号',
                      type: 'index',
                      width: 80,
                      align: 'center'
                    },
                    {
                        title: '用友系统卡片编号',
                        key: 'yonyou_id',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '行政事业系统编号',
                        key: 'admin_id',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '固定资产名称',
                        key: 'name',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '增加日期',
                        key: 'add_date',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '计量单位',
                        key: 'unit',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '资产数量',
                        key: 'count',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '可借出数量',
                        key: 'can_use_count',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '资产原值',
                        key: 'full_price',
                        minWidth:135,
                        align: 'center'
                    },
//                    {
//                        title: '累计折旧',
//                        key: 'depreciation',
//                        minWidth:135,
//                        align: 'center'
//                    },
                    {
                        title: '资金来源',
                        key: 'fund_source',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '入账形式',
                        key: 'entry_type',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '所属单位',
                        key: 'belonged',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '所属部门',
                        key: 'department',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '使用状况',
                        key: 'use_state',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '资产存放地点',
                        key: 'location',
                        minWidth:135,
                        align: 'center'
                    },
//                    {
//                        title: '使用年限',
//                        key: 'use_year',
//                        minWidth:135,
//                        align: 'center'
//                    },
                    {
                        title: '财务负责人',
                        key: 'finance_person',
                        minWidth:135,
                        align: 'center'
                    },
//                    {
//                        title: '销账日期',
//                        key: 'cancel_date',
//                        minWidth:135,
//                        align: 'center'
//                    },
//                    {
//                        title: '注销人',
//                        key: 'cancel_person',
//                        minWidth:135,
//                        align: 'center'
//                    },
                    {
                        title: '发票编号',
                        key: 'invoice_number',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '减少方式',
                        key: 'cut_type',
                        minWidth:135,
                        align: 'center'
                    },
//                    {
//                        title: '变动日期',
//                        key: 'change_date',
//                        minWidth:135,
//                        align: 'center'
//                    },
//                    {
//                        title: '变动后使用部门',
//                        key: 'change_dep',
//                        minWidth:135,
//                        align: 'center'
//                    },
                    {
                        title: '使用面积',
                        key: 'square',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '供应商',
                        key: 'supplier',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '生产厂家',
                        key: 'manufacturer',
                        minWidth:135,
                        align: 'center'
                    },
                    {
                        title: '备注',
                        key: 'remarks',
                        minWidth:135,
                        ellipsis:true,
                        align: 'center'
                    },
                    {
                        title: '操作',
                        key: 'action',
                        width:350,
                        fixed: 'right',
                        align: 'center',
                        render: (h, params) => {
                        let rowData = params.row;
                        if(rowData.state=='已报废'){
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'success',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: (e) => {
                                            e.stopPropagation()
                                            this.qcode=true;
                                            this.qcodeSrc=parameters.domain+params.row.QR_path;
                                            this.QR_path=params.row.QR_path;
                                            this.HD_code=parameters.domain+params.row.ewm_img;
                                        }
                                    }
                                }, '二维码'),
                                h('Button', {
                                    props: {
                                        type: 'success',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: (e) => {
                                            e.stopPropagation()
                                            this.$router.push({
                                                name: 'asetDetail',
                                                params: params.row
                                            })

                                        }
                                    }
                                }, '查看'),
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                        disabled:true
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: (e) => {
                                            e.stopPropagation()
//                                            this.transfer(params.index,'trans')
                                        }
                                    }
                                }, '调拨'),
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                        disabled:true
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: (e) => {
                                            e.stopPropagation()
//                                            this.lend(params.index)
                                        }
                                    }
                                }, '借出'),
                                h('Button', {
                                    props: {
//                                        type: 'disabled',
                                        size: 'small',
                                        disabled:true
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        'click': e => {
                                            e.stopPropagation()
                                        }
                                    }
                                }, '已报废'),
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: (e) => {
                                            e.stopPropagation()
                                            this.remove(params.index)
                                        }
                                    }
                                }, '删除'),
                            ])
                        }else if(rowData.state=='待报废'){
                            if(rowData.can_use_count ==0){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.qcode=true;
                                                this.qcodeSrc=parameters.domain+params.row.QR_path;
                                                this.QR_path=params.row.QR_path;
                                                this.HD_code=parameters.domain+params.row.ewm_img;
                                            }
                                        }
                                    }, '二维码'),
                                    h('Button', {
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.$router.push({
                                                    name: 'asetDetail',
                                                    params: params.row
                                                })

                                            }
                                        }
                                    }, '查看'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.transfer(params.index,'trans')
                                            }
                                        }
                                    }, '调拨'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            disabled:true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
//                                                this.lend(params.index)
                                            }
                                        }
                                    }, '借出'),
                                    h('Button', {
                                        props: {
//                                        type: 'disabled',
                                            size: 'small',
                                            disabled:true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            'click': e => {
                                                e.stopPropagation()
                                            }
                                        }
                                    }, '待报废'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.remove(params.index)
                                            }
                                        }
                                    }, '删除'),
                                ])
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.qcode=true;
                                                this.qcodeSrc=parameters.domain+params.row.QR_path;
                                                this.QR_path=params.row.QR_path;
                                                this.HD_code=parameters.domain+params.row.ewm_img;
                                            }
                                        }
                                    }, '二维码'),
                                    h('Button', {
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.$router.push({
                                                    name: 'asetDetail',
                                                    params: params.row
                                                })

                                            }
                                        }
                                    }, '查看'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.transfer(params.index,'trans')
                                            }
                                        }
                                    }, '调拨'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.lend(params.index)
                                            }
                                        }
                                    }, '借出'),
                                    h('Button', {
                                        props: {
//                                        type: 'disabled',
                                            size: 'small',
                                            disabled:true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            'click': e => {
                                                e.stopPropagation()
                                            }
                                        }
                                    }, '待报废'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.remove(params.index)
                                            }
                                        }
                                    }, '删除'),
                                ])
                            }

                        }else{
                            if(rowData.can_use_count<rowData.count&&rowData.can_use_count==0){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.qcode=true;
                                                this.qcodeSrc=parameters.domain+params.row.QR_path;
                                                this.QR_path=params.row.QR_path;
                                                this.HD_code=parameters.domain+params.row.ewm_img;
                                            }
                                        }
                                    }, '二维码'),
                                    h('Button', {
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.$router.push({
                                                    name: 'buildAsets',
                                                    params: params.row
                                                })

                                            }
                                        }
                                    }, '修改'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.transfer(params.index,'trans')
                                            }
                                        }
                                    }, '调拨'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            disabled:true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
//                                                this.lend(params.index)
                                            }
                                        }
                                    }, '借出'),
                                    h('Button', {
                                        props: {
                                            type: 'warning',
                                            size: 'small',
                                            disabled:true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
//                                                this.transfer(params.index,'scrap')
                                            }
                                        }
                                    }, '报废'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.remove(params.index)
                                            }
                                        }
                                    }, '删除'),
                                ])
                            }else if(rowData.can_use_count<rowData.count&&rowData.can_use_count!=0){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.qcode=true;
                                                this.qcodeSrc=parameters.domain+params.row.QR_path;
                                                this.QR_path=params.row.QR_path;
                                                this.HD_code=parameters.domain+params.row.ewm_img;
                                            }
                                        }
                                    }, '二维码'),
                                    h('Button', {
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.$router.push({
                                                    name: 'buildAsets',
                                                    params: params.row
                                                })

                                            }
                                        }
                                    }, '修改'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.transfer(params.index,'trans')
                                            }
                                        }
                                    }, '调拨'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.lend(params.index)
                                            }
                                        }
                                    }, '借出'),
                                    h('Button', {
                                        props: {
                                            type: 'warning',
                                            size: 'small',
                                            disabled:true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
//                                                this.transfer(params.index,'scrap')
                                            }
                                        }
                                    }, '报废'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.remove(params.index)
                                            }
                                        }
                                    }, '删除'),
                                ])
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.qcode=true;
                                                this.qcodeSrc=parameters.domain+params.row.QR_path;
                                                this.QR_path=params.row.QR_path;
                                                this.HD_code=parameters.domain+params.row.ewm_img;
                                            }
                                        }
                                    }, '二维码'),
                                    h('Button', {
                                        props: {
                                            type: 'success',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.$router.push({
                                                    name: 'buildAsets',
                                                    params: params.row
                                                })

                                            }
                                        }
                                    }, '修改'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.transfer(params.index,'trans')
                                            }
                                        }
                                    }, '调拨'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.lend(params.index)
                                            }
                                        }
                                    }, '借出'),
                                    h('Button', {
                                        props: {
                                            type: 'warning',
                                            size: 'small',
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.transfer(params.index,'scrap')
                                            }
                                        }
                                    }, '报废'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small'
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: (e) => {
                                                e.stopPropagation()
                                                this.remove(params.index)
                                            }
                                        }
                                    }, '删除'),
                                ])
                            }

                        };
                        }

                    }
                ],
                assetsTable:{
                    name:'',
                    yonyou_id:'',
                    admin_id:'',
                    model:'',
                    class_code:'',
                    department:'',
                    full_price:'',
                    depreciation:'',
                    net_value:'',
                    count:'',
                    unit:'',
                    add_type:'',
                    add_date:'',
                    entry_date:'',
                    accounting_id:'',
                    build_area:'',
                    plate_number:'',
                    fund_source:'',
                    project_name:'',
                    invoice_number:'',
                    keeper:'',
                    remarks:'',
                    admin_doc:{filename:'',path:''},
                    asset_doc:'',
                    yonyou_doc:{filename:'',path:''},
                    manufacturer:'',
                    supplier:'',
                    square:'',
                    change_dep:'',
                    change_date:'',
                    cut_type:'',
                    cancel_person:'',
                    cancel_date:'',
                    finance_person:'',
                    use_year:'',
                    location:'',
                    usr_state:'',
                    company:'',
                    entry_type:'',
                    invoice_image:[],
                    contract_image:[],
                    asset_image:[],
                }

            }

        },
        methods: {
            cancel_date:function (data,type) {
                console.log(data);
                console.log(type);
                var that=this;
                switch (type){
                    case 'cancel':
                        that.assetsTable.cancel_date=data
                        console.log(that.assetsTable.cancel_date);
                        break;
                    case 'change_date':
                        that.assetsTable.change_date=data
                        console.log(that.assetsTable.change_date);
                        break;
                }

            },
            Detail:function (data) {
                console.log(data);
                this.$router.push({
                    name: 'asetDetail',
                    params: data
                })
            },
            qltime:function (data) {

                this.time_month=data
            },
          download_tmp:function () {
            let that = this;
            let params = {};
            params.data = {
              "path" : '/uploads/assetlist/assetTemp/AssetTemplate.xls'
            };
            params.url = "/manage/messagelist/download";
            params.token = window.localStorage.getItem("token");
            params.success=function(res){
              console.log(res);
              var blob = new Blob([res.data], {type: "application/octet-stream"}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
              var downloadElement = document.createElement('a');
              var href = window.URL.createObjectURL(blob); //创建下载的链接
              downloadElement.href = href;
              downloadElement.download = '批量导入模板.xls'; //下载后文件名
              document.body.appendChild(downloadElement);
              downloadElement.click(); //点击下载
              document.body.removeChild(downloadElement); //下载完成移除元素
              window.URL.revokeObjectURL(href); //释放掉blob对象
            }
            that.ajaxGet(params);
          },
            //下载二维码图
            download_code:function () {
//                var that=this
//                var url= this.QR_path
//                $("#download").attr('src',that.qcodeDownUrl+'?&token='+token+'&path='+url)
                let that = this;
                let params = {};
                params.data = {
                    "path" : this.QR_path
                };
                params.url = "/manage/messagelist/download";
                params.token = window.localStorage.getItem("token");
                params.success=function(res){
                    console.log(res);
                    var blob = new Blob([res.data], {type: "application/octet-stream"}); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
                    var downloadElement = document.createElement('a');
                    var href = window.URL.createObjectURL(blob); //创建下载的链接
                    downloadElement.href = href;
                    downloadElement.download = '二维码.jpg'; //下载后文件名
                    document.body.appendChild(downloadElement);
                    downloadElement.click(); //点击下载
                    document.body.removeChild(downloadElement); //下载完成移除元素
                    window.URL.revokeObjectURL(href); //释放掉blob对象
                }
                that.ajaxGet(params);
            },
            //获取筛选列表
            getTableList:function () {
                let that = this;
                let params = {};
                params.url = '/sys/assetfield/list';
                params.data = {};
                params.token = this.getKey('token');
                params.success = function (res) {
                    console.log(res);
                    that.tableColumnTitles=res.data.result.result[0].fields;
                    that.table_id=res.data.result.result[0]._id;
                };
                this.ajaxPost(params)
            },
            //全选字段列表
            handleCheckAllField:function () {
                if(this.checkAllField){
                    this.tableColumnTitles = this.columnFields;
                }else {this.tableColumnTitles = []}
            },
            //字段筛选
            fieldItemChange:function (data) {
                if(data.length == this.columnFields.length && this.columnFields.length>0){
                    this.checkAllField = true;
                }else {this.checkAllField = false;}
                let cloneColumnFields = deepCopy(this.columnFields);
                for (let i=0;i<this.columnFields.length;i++){
                    if(data.indexOf(this.columnFields[i]) == -1){
                        cloneColumnFields.removeByValue(this.columnFields[i])
                    }
                }
                this.tableColumnTitles = cloneColumnFields;
            },
            //字段排序
            handleFieldSort:function (item,type) {
                let index = this.columnFields.indexOf(item);
//                console.log(index);
                switch (type){
                    case 'up':
                        if(index<= 0){
                            return;
                        }else {
                            let temp = deepCopy(this.columnFields[index-1]);
                            this.columnFields[index-1] = deepCopy(this.columnFields[index]);
                            this.columnFields[index] = temp;
                            console.log(this.columnFields);
                        }
                        break;
                    case 'down':
                        if(index >= this.columnFields.length-1){
                            return;
                        }else {
                            let temp = deepCopy(this.columnFields[index+1]);
                            this.columnFields[index+1] = deepCopy(this.columnFields[index]);
                            this.columnFields[index] = temp;
                        }
                        break;
                }
            },
            //关闭筛选框保存选项
            saveTableList:function () {
                let that = this;
                let params = {};
                params.url = '/sys/assetfield/edit';
                params.data = {_id:this.table_id,fields:this.tableColumnTitles};
                console.log(params.data);
                params.token = this.getKey('token');
                params.success = function (res) {
                    console.log(res);
                };
                this.ajaxPost(params)
            },
            //部门列表
            getDepartment:function () {
                var that = this;
                var params = {};
                params.data = {};
                params.token = this.getKey('token');
                params.url = '/sys/department/list';
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.departmentList = res.data.result.result;
//                    that.recordPage.total = res.result.totalSize
//                    that.dataSourceList.reverse()

                }
                this.ajaxPost(params);
            },
            //查询
            search:function (page) {
                var that = this;
                var params = {};
                if(this.ql_state==undefined){
                    this.ql_state=''
                }
                if(this.ql_department==undefined){
                    this.ql_department=''
                }
                params.data = {
                    searchValue:{state:this.ql_state +'|#|like',department:this.ql_department+'|#|like',add_date:this.time_month+'|#|like',
                        name:this.ql_name+'|#|like',yonyou_id:this.ql_yonyou_id+'|#|like',admin_id:this.ql_admin_id+'|#|like',unit:this.ql_unit+'|#|like',count:this.ql_count+'|#|like',class_code:this.ql_class_code+'|#|like',
                        model:this.ql_model+'|#|like',location:this.ql_location+'|#|like',project_name:this.ql_project_name+'|#|like',invoice_number:this.ql_invoice_number+'|#|like',supplier:this.ql_supplier+'|#|like',
                        manufacturer:this.ql_manufacturer+'|#|like',accounting_id:this.ql_accounting_id+'|#|like',finance_person:this.ql_finance_person+'|#|like',fund_source:this.ql_fund_source+'|#|like'
                    },
                    pageSize:this.pageSize,

                };
              if(page === undefined || page === "" || isNaN(page)){
                params.data.page = 1;
              }else{
                params.data.page = page;
              }
                params.token = this.getKey('token');
                console.log(params.data);
                params.url = '/sys/assetlist/list';
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.dataSourceList = res.data.result.result;
                    that.totalSize=res.data.result.totalSize;
                    that.page=res.data.result.page;

                }
                this.ajaxPost(params);
            },
            changePage: function(page) {
                this.search(page);
            },
            //新增
            add:function () {
                this.$router.push('buildAsets')
            },
            //调拨和报废
            transfer:function (index,type) {
                if(type=='trans'){
                    this.transfer_dep=this.dataSourceList[index].department;
                }else if(type=='scrap'){
                    this.asset_name=this.dataSourceList[index].name
                    this.asset_model=this.dataSourceList[index].model
                }
                this.current_modal=type;
                this.modal_transfer=true;
                this.transfer_index=index;
            },
            //确认调拨
            transferSubmit:function () {
                var that = this;
                var params = {};
                params.data = {
                    _id:this.dataSourceList[this.transfer_index]._id,
                    id:this.dataSourceList[this.transfer_index].id,
                    name:this.dataSourceList[this.transfer_index].name,
                    department:this.dataSourceList[this.transfer_index].department,
                    realname:this.getKey('realname')
                };
                if(this.trans_department !=''){
                    params.data.in_department=this.trans_department;
                }else{
                    this.$Notice.warning({
                        title: '请选择调入部门'
                    });
                    return;
                }
                params.token = this.getKey('token');
                params.url = '/sys/transferrecord/new';
                console.log(params.data);
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.$Notice.success({
                        title: '调拨成功'
                    });
                    that.modal_transfer=false;
                    that.transfer_index=''
                    that.loadData()
//                    that.recordPage.total = res.result.totalSize
//                    that.dataSourceList.reverse()

                }
                this.ajaxPost(params);
            },
            //确认报废
            scrapSubmit:function () {
                var that = this;
                var params = {};
                params.data = this.dataSourceList[this.transfer_index];
                params.data.type = this.scrap_type;
                params.token = this.getKey('token');
                params.url = '/sys/scraprecord/new';
                console.log(params.data);
                params.success = function(res) {
                    that.$Loading.finish();
                    that.$Notice.success({
                        title: '报废成功'
                    });
                    that.modal_transfer=false;
                    that.transfer_index='';
                    that.loadData()
                    console.log(res);
//                    that.dataSourceList = res.result;
//                    that.recordPage.total = res.result.totalSize
//                    that.dataSourceList.reverse()

                }
                this.ajaxPost(params);
            },
            //借出
            lend:function (data) {
                this.modal_lend=true;
                this.lend_dep=this.dataSourceList[data].department;
                this.transfer_index=data;
                this.asset_count=Number(this.dataSourceList[data].count)
            },
            //确认借出
            lendSubmit:function () {
                var that = this;
                var params = {};
                params.data = {
                    id:this.dataSourceList[this.transfer_index].id,
                    name:this.dataSourceList[this.transfer_index].name,
                    department:this.lend_dep,
                    lend_type:this.lend_type,
                    return_time:'',
                    land_count:this.land_count,
                    lend_time:new Date().format('yyyy-MM-dd'),
                    remarks:this.dataSourceList[this.transfer_index].remarks,
                };
                if(this.lend_name!=''||this.lend_department!=''){
                    if(this.lend_type=='person'){
                        params.data.lender=this.lend_name;
                        params.data.lend_department='';
                        params.data.lend_company='';
                    }else if(this.lend_type=='department'&&this.lend_department!=''){
                        params.data.lender='';
                        params.data.lend_department=this.lend_department;
                        params.data.lend_company='';
                    }else if(this.lend_type=='company'){
                        params.data.lender='';
                        params.data.lend_department='';
                        params.data.lend_company=this.lend_name;
                    }
                }else {
                    this.$Notice.warning({
                        title: '请填写借出方信息'
                    });
                    return;
                }
                console.log(params.data);
                params.token = this.getKey('token');
                params.url = '/sys/lendrecord/new';
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.$Notice.success({
                        title: '保存成功'
                    });
                    that.loadData()
                    that.modal_lend = false;

                }
                this.ajaxPost(params);
            },
            //加载列表数据
            loadData: function(page){
                console.log(8888);
                var that = this;
                var params = {};
                page = page == '' || page == undefined?this.page:page;
                params.data = {
                    "order":{"yonyou_id":1},
                    pageSize:this.pageSize,
                    page:page
                };
                if(page === undefined || page === "" || isNaN(page)){
                    params.data.page = 1;
                }else{
                    params.data.page = page;
                }
                params.token = this.getKey('token');
                params.url = '/sys/assetlist/list';
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.dataSourceList = res.data.result.result;
//                    for(let i=0;i<that.dataSourceList.length;i++){
//                        that.dataSourceList[i].cancel_date=new Date(that.dataSourceList[i].cancel_date).format('yyyy-MM-dd');
//                        that.dataSourceList[i].change_date =new Date(that.dataSourceList[i].change_date).format('yyyy-MM-dd');
//                    }
                    that.totalSize=res.data.result.totalSize;
                    that.page=res.data.result.page;
                    console.log(that.dataSourceList);

                }
                this.ajaxPost(params);
            },

          handleSuccess (res,file) {
            console.log(res);
//            file.name=res.result.filename;
//            file.url=res.result.path;
//            this.file.filename=res.result.filename;
//            this.file.path=res.result.path;
            this.$Message.success('批量上传可能需要等待几分钟！');
            if(res.code=='0001'||res.code=='0002'){
              this.$Message.error({
                content: res.message
              });
            }
            this.loadData();
          },
          handleFormatError(file){
            this.$Notice.warning({
              title: '文件格式错误',
              desc: '上传文件格式错误，需要上传用友系统xls或xlsx文件'
            });
          },
//            changePage: function(page) {
//                this.loadData(page);
//            },
            //删除
            remove (index) {
                this.modal_del=true;
                this.del_index=index;
            },
            del() {
                var that=this;
                var params = {};
                params.data = {'_id':this.dataSourceList[this.del_index]._id};
                params.token = this.getKey('token');
                params.url = '/sys/assetlist/delete';
                params.success = function(res) {
                    console.log(res);
                    that.$Loading.finish();
                    that.loadData()
                };

                this.ajaxPost(params);
                this.modal_loading = true;
                setTimeout(() => {
                    this.modal_loading = false;
                    this.modal_del = false;
                    this.$Message.success('删除成功');
                    this.del_index=''
                }, 1000);
            },
            //取消模态框
            cancel:function () {
                this.editMsg=false;

            },
//            //上传文件成功回掉
//            handleSuccess (res,file) {
//                console.log(res);
//                console.log(file);
//                var that=this;
//                var obj={};
//                obj.filename=res.result.filename;
//                obj.path=res.result.path;
//                console.log(obj);
//                switch (res.result.type){
//                    case 'Admin':
//                        that.assetsTable.admin_doc=res.result.filename;
//                        break;
//                    case 'Yonyou':
//                        that.assetsTable.yonyou_doc=obj;
//                        that.assetsTable.count=res.result.result_msg.count;
//                        that.assetsTable.full_price=res.result.result_msg.full_price;
//                        that.assetsTable.model=res.result.result_msg.model;
//                        that.assetsTable.name=res.result.result_msg.name;
//                        that.assetsTable.net_value =res.result.result_msg.net_value;
//                        that.assetsTable.unit=res.result.result_msg.unit;
//                        that.assetsTable.add_date =res.result.result_msg.add_date;
//                        that.assetsTable.add_type =res.result.result_msg.add_type;
//                        that.assetsTable.build_area =res.result.result_msg.build_area;
//                        that.assetsTable.class_code =res.result.result_msg.class_code;
//                        that.assetsTable.department =res.result.result_msg.department;
//                        that.assetsTable.fund_source =res.result.result_msg.fund_source;
//                        that.assetsTable.keeper =res.result.result_msg.keeper;
//                        that.assetsTable.plate_number =res.result.result_msg.plate_number;
//                        that.assetsTable.yonyou_id =res.result.result_msg.yonyou_id;
//                        break;
//                    case 'Assetdoc':
//                        that.assetsTable.asset_doc=res.result.filename;
//                        break;
//                }
//                this.$Message.success('上传成功')
//            },
//            //上传图片回调
//            handleUploadSuccess:function (res,file) {
//                console.log(res);
//                console.log(file);
//                let uploadFilePath = res.result.path.substring(0);
//                switch (res.result.type){
//                    case 'Contract':
//                        this.assetsTable.contract_image.push(uploadFilePath);
//                        break;
//                    case 'Invoice':
//                        this.assetsTable.invoice_image.push(uploadFilePath);
//                        this.assetsTable.count=res.result.read_img.count;
//                        this.assetsTable.entry_date=res.result.read_img.entry_date;
//                        this.assetsTable.full_price=res.result.read_img.full_price;
//                        this.assetsTable.invoice_number=res.result.read_img.invoice_number;
//                        this.assetsTable.model=res.result.read_img.model;
//                        this.assetsTable.name=res.result.read_img.name;
//                        this.assetsTable.net_value =res.result.read_img.net_value;
//                        this.assetsTable.unit=res.result.read_img.unit;
//                        break;
//                    case 'Asset':
//                        this.assetsTable.asset_image.push(uploadFilePath);
//                        break;
//                }
//            },
//            //删除上传的文件
//            handleUploadRemove:function (file,fileList) {
//                this.$Modal.confirm({
//                    content:'确定删除该图片？',
//                    onOk:function () {
//                        fileList.removeByValue(file);
//                    }
//                })
//            },
//            //
//            handleFormatError:function (file) {
//                this.$Modal.error({content:'文件格式不对，请上传jpg或png格式的图片'})
//            },
//            handleError:function (file) {
//                this.$Modal.error({content:'文件格式不对，请上传xls格式的文件'})
//            },
//            //查看大图
//            handleView:function (visible,imagePath) {
//                this.editMsg = !visible;
//                this.imageViewVisible = visible;
//                this.viewPath = imagePath;
//            }
        },
        mounted: function () {
            this.getDepartment();
            this.getTableList();
            this.loadData();
        },
        computed: {
            tableColumns:function () {
                var that=this;
                let columnTitles = [];
                console.log(this.tableColumnTitles);
                this.tableColumnTitles.map((item)=>{
                    for(let i=0;i<that.columns1.length;i++){
                        if(item==that.columns1[i].title){
                            columnTitles.push(that.columns1[i])
                        }
                    }
//                    let obj = {title:item,key:item,align: 'center'};

                });
                let obj=this.columns1[this.columns1.length-1];
                if(columnTitles.length!=0){
                    columnTitles.push(obj);
                }
                console.log(columnTitles);
                return columnTitles;
            },
        },
        watch:{
            columnFieldsModalShow:function(newColumnFieldsModalShow){
                if(newColumnFieldsModalShow == false){
                    this.saveTableList()
                }
            },
            'modal_lend':function () {
                if(this.modal_lend==false){
                    this.lend_type='';
                    this.lend_name='';
                    this.lend_department='';

                }
            },
            'modal_transfer':function () {
                if(this.modal_transfer==false){
                    this.trans_department=''
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/propertyMana/asetsList.vue